// extracted by mini-css-extract-plugin
module.exports = {"container":"F2wD_"};